import React from 'react';
import { FaChevronLeft, FaCheckCircle } from 'react-icons/fa';

const MockTestInstructionsPage = ({ test, subject, onBack, onStartTest }) => {
    // Special instructions for Writing subject
    const isWriting = subject === 'Writing';

    // Function to get display name for subjects (same as in MockTestStartPage)
    const getSubjectDisplayName = (subjectKey) => {
        const displayNames = {
            'Maths': 'Mathematical Reasoning',
            'ThinkingSkills': 'Thinking Skills',
            'Reading': 'Reading',
            'Writing': 'Writing'
        };
        return displayNames[subjectKey] || subjectKey;
    };

    const subjectDisplayName = getSubjectDisplayName(subject);

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-teal-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                <div className="bg-white rounded-xl shadow-lg p-8">
                    {/* Back Button */}
                    <button
                        onClick={onBack}
                        className="flex items-center text-blue-600 hover:text-blue-800 transition-colors mb-6"
                    >
                        <FaChevronLeft className="mr-2" /> Back to Test Selection
                    </button>

                    {/* Test Header */}
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-gray-800 mb-4">
                            Mock Test {test.id.split('-')[2]} - {subjectDisplayName}
                        </h1>
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 max-w-2xl mx-auto">
                            <p className="text-blue-800 font-medium">
                                <strong>Duration:</strong> {
                                    subject === 'Reading'
                                        ? '45 minutes'
                                        : subject === 'Writing'
                                            ? '30 minutes'
                                            : '40 minutes'
                                }
                            </p>
                        </div>
                    </div>

                    {/* Instructions */}
                    <div className="bg-gray-50 rounded-lg p-6 mb-8">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                            Instructions for Online Mock Test
                        </h2>

                        <p className="text-gray-600 mb-6 text-center">
                            Please read the Instructions carefully before starting the test.
                        </p>

                        <div className="space-y-4 text-gray-700">
                            <div className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mt-1 mr-3 flex-shrink-0">1</span>
                                <p>Click <strong>START TEST</strong> to proceed to the {subjectDisplayName} Task. The countdown timer will then start.</p>
                            </div>

                            <div className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mt-1 mr-3 flex-shrink-0">2</span>
                                <p>
                                    {isWriting
                                        ? 'Click START WRITING to proceed to answer the question. You can type your answer in the box provided.'
                                        : 'Read each question carefully and select your answer from the options provided.'
                                    }
                                </p>
                            </div>

                            <div className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mt-1 mr-3 flex-shrink-0">3</span>
                                <p>
                                    {isWriting
                                        ? 'Click BACK TO DESCRIPTION to see description.'
                                        : 'Click PREVIOUS to see previous question.'
                                    }</p>
                            </div>

                            <div className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mt-1 mr-3 flex-shrink-0">4</span>
                                <p>Do not click  <strong>SUBMIT</strong> button unless you have reviewed all the answers. You will not be allowed to change your answers once you click the Submit test button .</p>
                            </div>
                            {isWriting && (
                                <>
                                    <div className="flex items-start">
                                        <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mt-1 mr-3 flex-shrink-0">5</span>
                                        <p><strong>No plagiarism.</strong> All work must be your own.</p>
                                    </div>
                                    <div className="flex items-start">
                                        <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mt-1 mr-3 flex-shrink-0">6</span>
                                        <p><strong>Formatting is not marked.</strong> Focus on content and accuracy.</p>
                                    </div>

                                    <div className="flex items-start">
                                        <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mt-1 mr-3 flex-shrink-0">7</span>
                                        <p><strong>Word Limit:</strong> Your response should be approximately 300 words.</p>
                                    </div>
                                    <div className="flex items-start">
                                        <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mt-1 mr-3 flex-shrink-0">8</span>
                                        <p><strong>Character Description:</strong> You will be asked to write a narrative containing a full description of your main character.</p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Start Test Button */}
                    <div className="text-center">
                        <button
                            onClick={onStartTest}
                            className="start-test-button"
                        >
                            {isWriting ? 'START WRITING' : 'START TEST'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MockTestInstructionsPage;